// import store from '@/store'
// import consts from "@/consts";
import shipments_locator from '@/router/intuit/shipments/locator.js';

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.shipments') ? [] : [
    {
        path: 'login',
        name: 'Login',
        meta: {isGuest: true, hideMap: true},
        component: () => import('@/views/intuit/shipments/LoginPage.vue')
    },
    ...shipments_locator,
]

export default routes